/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const RefundStatus = {
  Created: "created",
  Pending: "pending",
  Completed: "completed",
  Failed: "failed",
} as const;
export type RefundStatus = ClosedEnum<typeof RefundStatus>;

/** @internal */
export const RefundStatus$inboundSchema: z.ZodNativeEnum<typeof RefundStatus> =
  z.nativeEnum(RefundStatus);
/** @internal */
export const RefundStatus$outboundSchema: z.ZodNativeEnum<typeof RefundStatus> =
  RefundStatus$inboundSchema;
